var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("loading", {
        attrs: { active: _vm.isLoading, "is-full-page": true },
        on: {
          "update:active": function($event) {
            _vm.isLoading = $event
          }
        }
      }),
      _c("div", { staticClass: "order-detail-footer" }, [
        _c(
          "div",
          {
            staticClass: "footer",
            class: { ml0: !_vm.showMenu, ml220: _vm.showMenu }
          },
          [
            _c("div", { staticClass: "content" }, [
              _c("div", { staticClass: "row group-status" }, [
                _c("div", { staticClass: "col-md-3 col-xs-12" }, [
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-xs btn-status",
                      style: {
                        "background-color": _vm.order.statusDetail
                          ? _vm.order.statusDetail.color
                          : "#fff",
                        cursor: "context-menu"
                      },
                      attrs: { href: "javascript: void(0)" }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.order.id +
                            " - " +
                            (_vm.order.statusDetail
                              ? _vm.order.statusDetail.title ||
                                _vm.order.statusDetail.name
                              : "")
                        )
                      )
                    ]
                  )
                ]),
                _c("div", { staticClass: "col-md-9 col-xs-12 text-right" }, [
                  _vm.order.status === 0
                    ? _c(
                        "a",
                        {
                          staticClass: "btn btn-status btn-deposit mr10",
                          attrs: { href: "javascript: void(0)" },
                          on: {
                            click: function($event) {
                              return _vm.onActionStatus(_vm.actions.deposit)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                            Đặt cọc\n                        "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.order.status === 0
                    ? _c(
                        "a",
                        {
                          staticClass: "btn btn-status btn-order-cancel",
                          attrs: { href: "javascript: void(0)" },
                          on: {
                            click: function($event) {
                              return _vm.onActionStatus(_vm.actions.cancel)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                            Hủy đơn hàng\n                        "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.order.status === 9 || _vm.order.status === 13
                    ? _c(
                        "a",
                        {
                          staticClass: "btn btn-status btn-complain",
                          attrs: { href: "javascript: void(0)" },
                          on: {
                            click: function($event) {
                              return _vm.onActionStatus(_vm.actions.complain)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                            Khiếu nại\n                        "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.order.status === 1
                    ? _c(
                        "a",
                        {
                          staticClass: "btn btn-status btn-order-reorder",
                          attrs: { href: "javascript: void(0)" },
                          on: {
                            click: function($event) {
                              return _vm.onActionStatus(_vm.actions.reorder)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                            Đặt lại\n                        "
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ])
            ])
          ]
        )
      ]),
      _vm.isConfirm
        ? _c("confirm-modal", {
            attrs: {
              content: _vm.modalContent,
              isShowQR: _vm.isShowQR,
              moneyRecharge: _vm.moneyRecharge,
              showNextButton: _vm.showNextConfirm
            },
            on: {
              eventCloseModal: function($event) {
                return _vm.onCloseModal($event)
              },
              eventAcceptModal: function($event) {
                return _vm.onAcceptModal($event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }